module.exports = __webpack_public_path__ + "img/products.dbbc70c6.png";